module.exports = __webpack_public_path__ + "img/yhyouhui.ad28354c.gif";